export const state = {
  applicants: [],
  recruiters: [],
  list: [],
  accounts: [],
}
